import ArchiveBoxIcon from '@atlaskit/icon/core/archive-box';
import * as React from 'react';

export function SvgArchive() {
  return <ArchiveBoxIcon label="" testId="ads-refreshed-icon" />;
}
